import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { AgreementDelivery } from './AgreementDelivery'
import { AgreementDeliveryConfirm } from './AgreementDeliveryConfirm'

const { AGREEMENT } = window.PATH
export default class Agreement extends React.PureComponent {
  render () {
    return <Switch>
      <Route path={AGREEMENT.DELIVERY} component={AgreementDelivery}/>
      <Route path={AGREEMENT.DELIVERY_CONFIRM} component={AgreementDeliveryConfirm}/>
    </Switch>
  }
}
